import React, { useState, useEffect } from "react";

import axios from "axios";
import { baseURL } from "@/utility/api";
import InternshipHero from "@/components/InternshipCohort/InternshipHero";
import InternshipWhatYoullGet from "@/components/InternshipCohort/InternshipWhatYoullGet";
import InternshipSelectionProcess from "@/components/InternshipCohort/InternshipSelectionProcess";
import InternshipTestimonial from "@/components/InternshipCohort/InternshipTestimonial";
import InternshipFAQ from "@/components/InternshipCohort/InternshipFAQ";
import InternshipFinal from "@/components/InternshipCohort/InternshipFinal";

// Main Page Component
const SecondCohortPage = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [details, setDetails] = useState({
    price: 1000,
    canApply: true,
    seats_left: 30,
  });

  useEffect(() => {
    setIsVisible(true);

    async function fetchData() {
      const response = await axios.post(`${baseURL}/cohort/get-details`, {
        id: 104,
      });
      // console.log("yo: ", response);
      setDetails(response.data);
    }

    fetchData();
  }, []);

  // console.log(details);

  return (
    <div className="min-h-screen bg-black text-white font-inter  md:px-0">
      {/* Hero Section */}
      <InternshipHero details={details} />

      <InternshipWhatYoullGet />
      <InternshipSelectionProcess details={details} />
      <InternshipTestimonial />
      <InternshipFAQ />
      <InternshipFinal />
    </div>
  );
};

export default SecondCohortPage;
